// extracted by mini-css-extract-plugin
export default {"closeButton":"page-module__closeButton___3pEYh"};